<app-breadcrumb></app-breadcrumb>
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <app-system-wide-message></app-system-wide-message>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <h2>{{ stop }}</h2>

      <div class="row d-flex p-2 text-center">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a
              class="nav-item nav-link active"
              id="nav-arrivals-tab"
              data-toggle="tab"
              href="#nav-arrivals"
              role="tab"
              aria-controls="nav-arrivals"
              aria-selected="true"
            >
              <span class="badge">
                Arrivals
              </span>
            </a>
            <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">&nbsp;&nbsp;&nbsp;&nbsp;</a>
          </div>
        </nav>
      </div>
      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="nav-arrivals"
          role="tabpanel"
          aria-labelledby="nav-arrivals-tab"
        >
          <br />
          <div class="border-bottom mb-3" *ngFor="let trip of data">
            <p *ngIf="trip.mode == 'rail'">
              Trip: <strong>{{ trip.id }}</strong>
            </p>
            <p *ngIf="trip.mode == 'rail'">
              Line: <strong>{{ trip.route }}</strong>
            </p>
            <p *ngIf="trip.mode == 'transit'">
              Route: <strong>{{ trip.route }}</strong>
            </p>
            <p *ngIf="trip.mode == 'rail'">
              Origin: <strong> {{ trip.origin }} </strong>
            </p>
            <p>
              Destination: <strong> {{ trip.destination }} </strong>
            </p>
            <p>
              Scheduled Time: <strong> {{ trip.scheduled | date: "shortTime" }} </strong>
            </p>
            <p *ngIf="trip.mode == 'rail'">
              Status: <strong> {{ trip.status }} </strong>
            </p>
            <p *ngIf="trip.mode == 'rail'">
              Type: <strong> {{ trip.type }} </strong>
            </p>
          </div>
          <div *ngIf="data.length < 1"><p>There are currently no arrivals for this stop.</p></div>
        </div>
        <div
          class="tab-pane fade"
          id="nav-info"
          role="tabpanel"
          aria-labelledby="nav-info-tab"
        >
          <br />
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Stop</th>
                <th scope="col">Scheduled</th>
                <th scope="col" class="d-none d-sm-table-cell">Estimated</th>
                <th scope="col">Actual</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let schedule of data">
                <td scope="row">{{ schedule.stop }}</td>
                <td>{{ schedule.scheduled }}</td>
                <td class="d-none d-sm-table-cell">{{ schedule.estimated }}</td>
                <td>{{ schedule.actual }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div>
        <span class="badge">Map</span>
        <div class="card mt-2">
          <div>
            <app-embedded-map-single></app-embedded-map-single>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-main-footer></app-main-footer>